import { useRecoilValue } from 'recoil';
import { selectedDeliveryFenceIdState } from '../../storage/deliveryFences';
import { DeliveryFenceDetail } from '../deliveryFences/DeliveryFenceDetail';
import { DeliveryFenceList } from '../deliveryFences/DeliveryFencesList';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { DeliveryFencesProvider } from '../providers/DeliveryFencesProvider';

export function DeliveryFencesPage() {
  const selectedDeliveryFenceId = useRecoilValue(selectedDeliveryFenceIdState);

  return (
    <>
      <DeliveryFencesProvider />
      <FloatingCardsLayout
        contentSize={350}
        list={<DeliveryFenceList />}
        content={selectedDeliveryFenceId !== undefined && <DeliveryFenceDetail />}
      />
    </>
  );
}
